import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { Provider } from 'react-redux';
import store from './redux/store';
import { LoadingProvider } from './components/LoadingContext';
import './styles/App.css';

ReactDOM.createRoot(document.getElementById('root')).render(
  <Provider store={store}>
    <LoadingProvider>
      <App />
    </LoadingProvider>
  </Provider>
);
